<template>
  <div id="app">
    <!-- Main content where the router will render the pages -->
    <router-view />
  </div>
</template>



<style>
@import '@/assets/styles.css'; /* Import your global styles here */

/* Basic styles for the app container */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
</style>
